var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoorUnit1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7498 12.7498C17.9363 12.9356 18.0842 13.1564 18.1852 13.3995C18.2861 13.6426 18.3381 13.9033 18.3381 14.1665C18.3381 14.4297 18.2861 14.6904 18.1852 14.9335C18.0842 15.1766 17.9363 15.3974 17.7498 15.5832L15.5832 17.7498C15.3974 17.9363 15.1766 18.0842 14.9335 18.1852C14.6904 18.2861 14.4297 18.3381 14.1665 18.3381C13.9033 18.3381 13.6426 18.2861 13.3995 18.1852C13.1564 18.0842 12.9356 17.9363 12.7498 17.7498L2.24984 7.24983C1.8753 6.87348 1.66504 6.36413 1.66504 5.83317C1.66504 5.30221 1.8753 4.79285 2.24984 4.4165L4.4165 2.24984C4.79285 1.8753 5.30221 1.66504 5.83317 1.66504C6.36413 1.66504 6.87348 1.8753 7.24983 2.24984L17.7498 12.7498Z",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 10.4167L13.7502 8.75",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5835 7.91667L11.2502 6.25",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 5.41667L8.75016 3.75",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 12.9167L16.2502 11.25",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorUnit1Icon);
export default __webpack_public_path__ + "static/media/outdoor_unit_1_icon.539ea4f423cb821f41e25a8a4c6ccfa1.svg";
export { ForwardRef as ReactComponent };